var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclecheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8C14 4.69 11.31 2 8 2C4.69 2 2 4.69 2 8C2 11.31 4.69 14 8 14C11.31 14 14 11.31 14 8ZM0 8C0 3.58 3.58 0 8 0C12.42 0 16 3.58 16 8C16 12.42 12.42 16 8 16C3.58 16 0 12.42 0 8ZM6.29 10.71C6.49 10.9 6.74 11 7 11C7.26 11 7.51 10.9 7.7 10.71L11.7 6.71C12.09 6.32 12.09 5.69 11.7 5.3C11.31 4.91 10.68 4.91 10.29 5.3L7 8.59L5.7 7.3C5.31 6.91 4.68 6.91 4.29 7.3C3.9 7.69 3.9 8.32 4.29 8.71L6.29 10.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclecheck);
export default __webpack_public_path__ + "static/media/circlecheck.7473141025c0901410b25cba1ac7d5c2.svg";
export { ForwardRef as ReactComponent };